import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { ApComplexModal, ModalHelperServiceBase } from 'webcommon/core-ui/modals-ng1520';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from 'webcommon/core-ui/pipes-ng1520';

@Component({
  selector: 'ap-confirm-modal',
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
  styleUrls: ['ap-confirm-modal.component.less'],
  templateUrl: './ap-confirm-modal.component.html',
})
export class ApConfirmModalComponent extends ApComplexModal<boolean> implements OnInit {
  override modalData: {
    baseId: string;
    bodyText: string;
    modalTitleText: string;
    noButtonText: string;
    yesButtonText: string;
    hideHeader: boolean | null;
    hideNoButton: boolean | null;
  } = this.getModalData();

  Id = `${this.modalData.baseId}-confirm-modal`;

  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  private readonly modalHelperService = inject(ModalHelperServiceBase);

  override ngOnInit(): void {
    super.ngOnInit();
    this.modalHelperService.appendModalOverrideClass(this.element);
  }

  yesSelected() {
    this.apClose(true);
  }

  noSelected() {
    this.apClose(false);
  }
}
